var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSocialTwitter = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 13,
  height: 10,
  fill: "none",
  viewBox: "0 0 13 10"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#696969",
  d: "M12.301 1.186c-.452.2-.938.336-1.45.397a2.53 2.53 0 0 0 1.11-1.396 5.038 5.038 0 0 1-1.602.612 2.525 2.525 0 0 0-4.3 2.302A7.167 7.167 0 0 1 .856.464a2.523 2.523 0 0 0-.044 2.46c.196.366.48.679.825.91a2.518 2.518 0 0 1-1.143-.316v.032a2.525 2.525 0 0 0 2.024 2.475c-.372.1-.761.116-1.14.043a2.525 2.525 0 0 0 2.358 1.753A5.064 5.064 0 0 1 0 8.866 7.138 7.138 0 0 0 3.868 10c4.643 0 7.181-3.845 7.181-7.18 0-.109-.003-.218-.008-.327.494-.357.92-.799 1.259-1.305l.001-.002Z"
})));
export default SvgSocialTwitter;